import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import OrdenCompraIngreso from './views/OrdenCompraIngreso.vue'
import Login from './views/Login.vue'
import OrdenCompraDetalle from './views/OrdenCompraDetalle.vue' 
import OrdenCompraMateriales from './views/OrdenCompraMateriales.vue' 
import OrdenCompraPrecios from './views/OrdenCompraPrecios.vue' 
import OrdenCompraAceptadas from './views/OrdenCompraAceptadas.vue' 
import OrdenCompraCanceladas from './views/OrdenCompraCanceladas.vue' 
import OrdenCompraPendienteAceptada from './views/OrdenCompraPendienteAceptada.vue' 
import OrdenCompraRecepcionConforme from './views/OrdenCompraRecepcionConforme.vue' 
import OrdenCompraNoAceptada from './views/OrdenCompraNoAceptada.vue' 
import OrdenCompraContratos from './views/OrdenCompraContratos.vue' 
import OrdenCompraEjecutivos from './views/OrdenCompraEjecutivos.vue' 
import ReporteHistorico from './views/ReporteHistorico.vue' 
import ReporteMensual from './views/ReporteMensual.vue' 
import ProductosCM from './views/ProductosCM.vue'
import TendenciasCM from './views/TendenciasCM.vue' 
import DashboardCM from './views/DashboardCM.vue' 
Vue.use(Router)
const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        public: true,
      }
    },
    {
      path: '/login',
      meta: {
        public: true,
      },
      name: 'Login',
      component: Login,
    },
    {
      path: '/home/:hash',
      name: 'Home',
      component: Home,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompraingreso/:hash',
      name: 'OrdenCompraIngreso',
      component: OrdenCompraIngreso,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompraingreso',
      name: 'OrdenCompraIngreso',
      component: OrdenCompraIngreso,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompraaceptadas/:hash',
      name: 'OrdenCompraAceptadas',
      component: OrdenCompraAceptadas,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompracanceladas/:hash',
      name: 'OrdenCompraCanceladas',
      component: OrdenCompraCanceladas,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencomprapendienteaceptada/:hash',
      name: 'OrdenCompraPendienteAceptada',
      component: OrdenCompraPendienteAceptada,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencomprarecepcionconforme/:hash',
      name: 'OrdenCompraRecepcionConforme',
      component: OrdenCompraRecepcionConforme,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompranoaceptada/:hash',
      name: 'OrdenCompraNoAceptada',
      component: OrdenCompraNoAceptada,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompraaceptadas',
      name: 'OrdenCompraAceptadas',
      component: OrdenCompraAceptadas,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompracanceladas',
      name: 'OrdenCompraCanceladas',
      component: OrdenCompraCanceladas,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencomprapendienteaceptada',
      name: 'OrdenCompraPendienteAceptada',
      component: OrdenCompraPendienteAceptada,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencomprarecepcionconforme',
      name: 'OrdenCompraRecepcionConforme',
      component: OrdenCompraRecepcionConforme,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompranoaceptada',
      name: 'OrdenCompraNoAceptada',
      component: OrdenCompraNoAceptada,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {

      path: '/ordenCompraDetalle/:hash',
      props: true,
      name: 'OrdenCompraDetalle',
      component: OrdenCompraDetalle,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },
    } ,
    {
      path: '/ordenCompraMateriales/:hash',
      name: 'OrdenCompraMateriales',
      component: OrdenCompraMateriales,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordenCompraMateriales',
      name: 'OrdenCompraMateriales',
      component: OrdenCompraMateriales,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordenCompraPrecios/:hash',
      name: 'OrdenCompraPrecios',
      component: OrdenCompraPrecios,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordenCompraPrecios',
      name: 'OrdenCompraPrecios',
      component: OrdenCompraPrecios,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordenCompraContratos/:hash',
      name: 'OrdenCompraContratos',
      component: OrdenCompraContratos,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordenCompraContratos',
      name: 'OrdenCompraContratos',
      component: OrdenCompraContratos,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/reportehistorico/:hash',
      name: 'ReporteHistorico',
      component: ReporteHistorico,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/reportehistorico',
      name: 'ReporteHistorico',
      component: ReporteHistorico,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/reportemensual/:hash',
      name: 'ReporteMensual',
      component: ReporteMensual,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/reportemensual',
      name: 'ReporteMensual',
      component: ReporteMensual,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompraejecutivos/:hash',
      name: 'OrdenCompraEjecutivos',
      component: OrdenCompraEjecutivos,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/ordencompraejecutivos',
      name: 'OrdenCompraEjecutivos',
      component: OrdenCompraEjecutivos,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },

    },
    {
      path: '/productosCM',
      name: 'ProductosCM',
      component: ProductosCM,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },


    },
    {
      path: '/productosCM:hash',
      name: 'ProductosCM',
      component: ProductosCM,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },


    },
     {
      path: '/tendenciasCM',
      name: 'TendenciasCM',
      component: TendenciasCM,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },


    },
    {
      path: '/tendenciasCM:hash',
      name: 'TendenciasCM',
      component: TendenciasCM,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },


    },
     {
      path: '/dashboardOCCM',
      name: 'DashboardOCCM',
      component: DashboardCM,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },


    },
    {
      path: '/dashboardOCCM:hash',
      name: 'DashboardOCCM',
      component: DashboardCM,
      meta: {
        breadcrumb: true,
        requiresAuth: true

      },


    },
  ]
});
//{ name: 'user-view', path: '/user/:id', component: UserView },
// router gards
function uuidv4() { 
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {   
  var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);   
  return v.toString(16);   
     });   
  }
router.beforeEach((to, from, next) => {
  //NProgress.start();
  debugger;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
      Vue.prototype.stopSignalR();
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath
        },
        query: { from: to.fullPath }
      });

      
    } else {
     
             
      var signalconn = Vue.prototype.isConnected();
      if(signalconn == null)
      {
        Vue.prototype.startSignalR(localStorage.getItem("jwt")) ;
      }
      if(to.path == '/ordencompraingreso' || to.path == 'ordencompraingreso')
      {
        next({name: "OrdenCompraIngreso",
        params: { hash: uuidv4() }});
      }
      else if(to.path == '/ordencompraaceptadas' || to.path == 'ordencompraaceptadas')
      {
        next({name: "OrdenCompraAceptadas",
        params: { hash: uuidv4() }});
      }
      else if(to.path == '/ordencompracanceladas' || to.path == 'ordencompracanceladas')
      {
        next({name: "OrdenCompraCanceladas",
        params: { hash: uuidv4() }});
      }
      else if(to.path == '/ordencomprapendienteaceptada' || to.path == 'ordencomprapendienteaceptada')
      {
        next({name: "OrdenCompraPendienteAceptada",
        params: { hash: uuidv4() }});
      }
      else if(to.path == '/ordencomprarecepcionconforme' || to.path == 'ordencomprarecepcionconforme')
      {
        next({name: "OrdenCompraRecepcionConforme",
        params: { hash: uuidv4() }});
      }
      else if(to.path == '/ordencompranoaceptada' || to.path == 'ordencompranoaceptada')
        {
          next({name: "OrdenCompraNoAceptada",
          params: { hash: uuidv4() }});
        }
      else if(to.path == '/ordenCompraDetalle' || to.path == 'ordenCompraDetalle')
      {
        next({name: "OrdenCompraDetalle",
        params: { hash: uuidv4() },
        query: to.query  });
      }
      else if(to.path == '/ordencompramateriales' || to.path == 'ordenCompraMateriales')
      {
        next({name: "OrdenCompraMateriales",
        params: { hash: uuidv4() },
        query: to.query  });
      }
      else if(to.path == '/ordencompraprecios' || to.path == 'ordenCompraPrecios')
      {
        next({name: "OrdenCompraPrecios",
        params: { hash: uuidv4() },
        query: to.query  });
      }
      else if(to.path == '/ordencompracontratos' || to.path == 'ordenCompraContratos')
      {
        next({name: "OrdenCompraContratos",
        params: { hash: uuidv4() },
        query: to.query  });
      }
      else if(to.path == '/reportehistorico' || to.path == 'reportehistorico')
      {
        next({name: "ReporteHistorico",
        params: { hash: uuidv4() },
        query: to.query  });
      }
      else if(to.path == '/reportemensual' || to.path == 'reportemensual')
      {
        next({name: "ReporteMensual",
        params: { hash: uuidv4() },
        query: to.query  });
      }
      else if(to.path == '/ordencompraejecutivos' || to.path == 'ordencompraejecutivos')
      {
        next({name: "OrdenCompraEjecutivos",
        params: { hash: uuidv4() },
        query: to.query  });
      }
      else
      {
         next();
        
      }
     
     
    }
  } else if (to.matched.some(record => record.meta.public)) {
    if (localStorage.getItem('jwt') == null) {
      next();
    } else {
      /*
      next({
        name: 'Home'
      });*/
      next({name: "OrdenCompraIngreso",
      params: { hash: uuidv4() }});
    }
  } else {
    //next();
    Vue.prototype.stopSignalR();
    next({
      path: '/login'
    });
  }

});

export default router;
 